import { render, staticRenderFns } from "./TagBasicIcon.vue?vue&type=template&id=5514a63a&scoped=true"
import script from "./TagBasicIcon.vue?vue&type=script&lang=js"
export * from "./TagBasicIcon.vue?vue&type=script&lang=js"
import style0 from "./TagBasicIcon.vue?vue&type=style&index=0&id=5514a63a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5514a63a",
  null
  
)

export default component.exports